import EnumSocket from "../Enums/EnumSocket"

export const GAME_ROOM_WS_URL = process.env.REACT_APP_WS_URL + EnumSocket.GAME_ROOM
export const FRIENDSHIP_ROOM_WS_URL = process.env.REACT_APP_WS_URL + EnumSocket.FRIENDSHIP_ROOM